import Loader from 'reusable/mobx-helpers/Loader'
import { makeAutoObservable } from 'mobx'
import { CreateClientAutocompleteParams } from './CreateClientAutocomplete'
import { FormHandlerConfig, formHandler } from 'reusable/mobx-store-utils/form-handlers/new/form-handler'
import { GapAutocompleteOption } from 'features/gap-components/autocomplete/types/GapAutocompleteTypes'
import { createStoreContext } from 'reusable/mobx-store-utils/storeUtils'
import { AdvisorClientDto } from '@gap/backend/app-services/advisor/client/models/AdvisorClientDto'
import ModalState from 'reusable/mobx-helpers/ModalState'
import CacheStore from 'cache/CacheStore'

export default class CreateClientAutocompleteStore {
   loader = new Loader(false)
   fields: { clientId: string } = {
      clientId: ''
   }
   createClientModalState = new ModalState({ initial: false })
   newClient: string = ''
   sp
   showCreateClientTabOnOpen = true

   constructor(sp: Omit<CreateClientAutocompleteParams, 'label'> & { cacheStore: CacheStore }) {
      makeAutoObservable(this)
      this.sp = sp
   }

   get clients() {
      return this.sp.cacheStore.clientsCacheStore.selectableClients
   }

   get formHandler() {
      return formHandler(this.fields, {
         clientId: { type: 'string' }
      } satisfies FormHandlerConfig)
   }

   get clientOptions(): GapAutocompleteOption[] {
      if (!this.clients) {
         return []
      }

      return this.clients.map(client => ({
         id: client.id,
         label: `${client.name}`,
         isDemo: client.isDemo,
      }))
   }

   get hasClients() {
      return !!this.clients && this.clients.length > 0
   }

   openCreateClientModal = (inputValue: string) => {
      this.newClient = inputValue
      this.createClientModalState.open()
      this.showCreateClientTabOnOpen = true
   }

   openCreateClientModalWithXPM = () => {
      this.newClient = ''
      this.createClientModalState.open()
      this.showCreateClientTabOnOpen = false
   }

   /**
    * Prevents blur/close of the dropdown when interacting with the footer.
   */
   preventBlur = (e: React.MouseEvent) => {
      e.preventDefault()
   }

   /**
    * When the user selects a client from the autocomplete
   */
   onClientChange = (selectedClientId: string) => {
      this.fields.clientId = selectedClientId
      this.sp.onChange(selectedClientId)
   }

   /**
    * When a new client is created
   */
   onNewClientCreated = (newClient: AdvisorClientDto.idWithName) => {
      this.fields.clientId = newClient.id
      this.sp.onNewClientCreated?.(newClient)
      this.sp.onChange(this.fields.clientId)
      this.createClientModalState.close()
   }
}

export const { Provider: CreateClientAutocompleteStoreProvider, useProvidedStore: useCreateClientAutocompleteStore } =
   createStoreContext(CreateClientAutocompleteStore)
